// ─── Static Content Library for the Authenticated Homepage ───────────────────
// Content is rotated daily using a day-of-year index.

// ─── Quotes ──────────────────────────────────────────────────────────────────

export interface Quote {
  text: string;
  author: string;
}

export const QUOTES: Quote[] = [
  { text: "home_quote_1", author: "home_quote_1_author" },
  { text: "home_quote_2", author: "home_quote_2_author" },
  { text: "home_quote_3", author: "home_quote_3_author" },
  { text: "home_quote_4", author: "home_quote_4_author" },
  { text: "home_quote_5", author: "home_quote_5_author" },
  { text: "home_quote_6", author: "home_quote_6_author" },
  { text: "home_quote_7", author: "home_quote_7_author" },
  { text: "home_quote_8", author: "home_quote_8_author" },
  { text: "home_quote_9", author: "home_quote_9_author" },
  { text: "home_quote_10", author: "home_quote_10_author" },
  { text: "home_quote_11", author: "home_quote_11_author" },
  { text: "home_quote_12", author: "home_quote_12_author" },
  { text: "home_quote_13", author: "home_quote_13_author" },
  { text: "home_quote_14", author: "home_quote_14_author" },
  { text: "home_quote_15", author: "home_quote_15_author" },
  { text: "home_quote_16", author: "home_quote_16_author" },
  { text: "home_quote_17", author: "home_quote_17_author" },
  { text: "home_quote_18", author: "home_quote_18_author" },
  { text: "home_quote_19", author: "home_quote_19_author" },
  { text: "home_quote_20", author: "home_quote_20_author" },
  { text: "home_quote_21", author: "home_quote_21_author" },
  { text: "home_quote_22", author: "home_quote_22_author" },
  { text: "home_quote_23", author: "home_quote_23_author" },
  { text: "home_quote_24", author: "home_quote_24_author" },
  { text: "home_quote_25", author: "home_quote_25_author" },
  { text: "home_quote_26", author: "home_quote_26_author" },
  { text: "home_quote_27", author: "home_quote_27_author" },
  { text: "home_quote_28", author: "home_quote_28_author" },
  { text: "home_quote_29", author: "home_quote_29_author" },
  { text: "home_quote_30", author: "home_quote_30_author" },
];

// ─── Science Facts ───────────────────────────────────────────────────────────

export interface ScienceFact {
  text: string;
  source: string;
}

export const SCIENCE_FACTS: ScienceFact[] = [
  { text: "home_science_1", source: "home_science_1_source" },
  { text: "home_science_2", source: "home_science_2_source" },
  { text: "home_science_3", source: "home_science_3_source" },
  { text: "home_science_4", source: "home_science_4_source" },
  { text: "home_science_5", source: "home_science_5_source" },
  { text: "home_science_6", source: "home_science_6_source" },
  { text: "home_science_7", source: "home_science_7_source" },
  { text: "home_science_8", source: "home_science_8_source" },
  { text: "home_science_9", source: "home_science_9_source" },
  { text: "home_science_10", source: "home_science_10_source" },
  { text: "home_science_11", source: "home_science_11_source" },
  { text: "home_science_12", source: "home_science_12_source" },
  { text: "home_science_13", source: "home_science_13_source" },
  { text: "home_science_14", source: "home_science_14_source" },
  { text: "home_science_15", source: "home_science_15_source" },
  { text: "home_science_16", source: "home_science_16_source" },
  { text: "home_science_17", source: "home_science_17_source" },
  { text: "home_science_18", source: "home_science_18_source" },
  { text: "home_science_19", source: "home_science_19_source" },
  { text: "home_science_20", source: "home_science_20_source" },
  { text: "home_science_21", source: "home_science_21_source" },
  { text: "home_science_22", source: "home_science_22_source" },
  { text: "home_science_23", source: "home_science_23_source" },
  { text: "home_science_24", source: "home_science_24_source" },
  { text: "home_science_25", source: "home_science_25_source" },
  { text: "home_science_26", source: "home_science_26_source" },
  { text: "home_science_27", source: "home_science_27_source" },
  { text: "home_science_28", source: "home_science_28_source" },
  { text: "home_science_29", source: "home_science_29_source" },
  { text: "home_science_30", source: "home_science_30_source" },
];

// ─── Platform Tips ───────────────────────────────────────────────────────────

export interface PlatformTip {
  text: string;
  route: string;
}

export const PLATFORM_TIPS: PlatformTip[] = [
  { text: "home_tip_1", route: "/spaces" },
  { text: "home_tip_2", route: "/marketplace" },
  { text: "home_tip_3", route: "/portal?tab=my_workspace" },
  { text: "home_tip_4", route: "/portal?tab=activities" },
  { text: "home_tip_5", route: "/marketplace?tab=services" },
  { text: "home_tip_6", route: "/spaces" },
  { text: "home_tip_7", route: "/portal?tab=my_workspace" },
  { text: "home_tip_8", route: "/marketplace" },
  { text: "home_tip_9", route: "/spaces" },
  { text: "home_tip_10", route: "/portal" },
  { text: "home_tip_11", route: "/marketplace" },
  { text: "home_tip_12", route: "/spaces" },
  { text: "home_tip_13", route: "/portal?tab=my_workspace" },
  { text: "home_tip_14", route: "/marketplace?tab=services" },
  { text: "home_tip_15", route: "/portal" },
];

// ─── Philosophy (5-Step Method) ──────────────────────────────────────────────

export interface PhilosophyStep {
  number: number;
  titleKey: string;
  descKey: string;
  icon: "eye" | "book" | "target" | "rotate" | "sparkles";
}

export const PHILOSOPHY_STEPS: PhilosophyStep[] = [
  { number: 1, titleKey: "home_phil_1_title", descKey: "home_phil_1_desc", icon: "eye" },
  { number: 2, titleKey: "home_phil_2_title", descKey: "home_phil_2_desc", icon: "book" },
  { number: 3, titleKey: "home_phil_3_title", descKey: "home_phil_3_desc", icon: "target" },
  { number: 4, titleKey: "home_phil_4_title", descKey: "home_phil_4_desc", icon: "rotate" },
  { number: 5, titleKey: "home_phil_5_title", descKey: "home_phil_5_desc", icon: "sparkles" },
];

// ─── Quote Card Gradients (rotated by day-of-week) ──────────────────────────

export const QUOTE_GRADIENTS = [
  "from-violet-50/80 via-purple-50/40 to-fuchsia-50/60",
  "from-primary/5/80 via-indigo-50/40 to-sky-50/60",
  "from-emerald-50/80 via-teal-50/40 to-cyan-50/60",
  "from-amber-50/80 via-orange-50/40 to-yellow-50/60",
  "from-rose-50/80 via-pink-50/40 to-red-50/60",
  "from-indigo-50/80 via-blue-50/40 to-violet-50/60",
  "from-teal-50/80 via-emerald-50/40 to-green-50/60",
];

// ─── Rotation Helpers ────────────────────────────────────────────────────────

function getDayOfYear(): number {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now.getTime() - start.getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24));
}

/** Pick a daily-rotated item from an array */
export function getDailyItem<T>(items: T[], offset = 0): T {
  const dayIndex = (getDayOfYear() + offset) % items.length;
  return items[dayIndex];
}

export type WisdomType = "science" | "tip" | "quote";
const WISDOM_ROTATION: WisdomType[] = ["science", "tip", "quote"];

/** One wisdom item per day, rotating type: science (cited) → tip → quote. */
export const getDailyWisdomType = (date: Date = new Date()): WisdomType => {
  const start = new Date(date.getFullYear(), 0, 0);
  const dayOfYear = Math.floor((date.getTime() - start.getTime()) / 86400000);
  return WISDOM_ROTATION[dayOfYear % WISDOM_ROTATION.length];
};

/** Get today's quote */
export function getDailyQuote(): Quote {
  return getDailyItem(QUOTES);
}

/** Get today's science fact */
export function getDailyScienceFact(): ScienceFact {
  return getDailyItem(SCIENCE_FACTS);
}

/** Get a second science fact (for sidebar alternate) */
export function getAlternateScienceFact(): ScienceFact {
  return getDailyItem(SCIENCE_FACTS, 7);
}

/** Get today's platform tip */
export function getDailyTip(): PlatformTip {
  return getDailyItem(PLATFORM_TIPS);
}

/** Get today's quote gradient */
export function getDailyGradient(): string {
  return QUOTE_GRADIENTS[new Date().getDay()];
}
